import React from 'react'
import cx from 'classnames'

import { Text } from 'components/dataDisplay'

import s from './Tab.scss'


type TabProps = {
  id: string
  tagId: string
  title: Intl.Message | string
  isActive: boolean
  withMargin?: boolean
  onClick: (id: string) => void
}

const Tab: React.FunctionComponent<TabProps> = (props) => {
  const { id, tagId, title, isActive, withMargin, onClick } = props

  const rootClassName = cx(s.tab, {
    'ml-32': withMargin,
    [s.active]: isActive,
  })

  return (
    <Text
      className={rootClassName}
      id={tagId}
      message={title}
      style="h8"
      color={isActive ? 'gold-50' : 'black'}
      tag="button"
      role="tab"
      tabIndex={isActive ? 0 : -1}
      aria-controls={`${tagId}-panel`}
      aria-selected={isActive}
      data-testid={`${id}Tab`}
      onClick={() => onClick(id)}
      html
    />
  )
}


export default React.memo(Tab)
